/* eslint-disable */
/**
 * This file was generated by Itecho.TSGen tool
 * Version and info generated in .version
 * Any changes to this file will be lost if regenerated 
 */

import { webRequest, fileRequest } from "../request";
import type LoggerDisplay from "../interfaces/loggerDisplay";
import type PaginationRequestSearch from "../interfaces/paginationRequestSearch";
import type PaginationResponse from "../interfaces/paginationResponse";

export default {
    paged: (request: PaginationRequestSearch) => webRequest<PaginationResponse<LoggerDisplay>>('/api/logger/paged', {
        method: 'post',
        body: request
    })
}